var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35626 0.952759L3.89159 3.92247L0.614589 4.40023C0.0269265 4.48546 -0.208587 5.20995 0.21758 5.6249L2.58842 7.93518L2.02767 11.1987C1.92674 11.7886 2.54804 12.2305 3.06842 11.9546L6 10.4137L8.93158 11.9546C9.45196 12.2283 10.0733 11.7886 9.97233 11.1987L9.41158 7.93518L11.7824 5.6249C12.2086 5.20995 11.9731 4.48546 11.3854 4.40023L8.10841 3.92247L6.64374 0.952759C6.38131 0.423414 5.62093 0.416685 5.35626 0.952759Z",
    fill: "#EFA30F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a6eb1d7d16c49dee2a9bdf7198fee004.svg";
export { ForwardRef as ReactComponent };